// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a4e8482f","389":"e8733663","453":"fec386ec","455":"90db1227","977":"ce4b2ff4"}[chunkId] + ".chunk.js";
};